import { Navigate, Route } from 'react-router-dom';

import ChartListPage from '@/features/(charts)/chart-list/pages/chart-list-page';
import { FilterVisibilityPage } from '@/features/(settings)/filter-visibility';
import { ProductManagerPage } from '@/features/Product/pages/ProductManagerPage';
import { ScrapingDetailPage } from '@/features/Scraping/pages/ScrapingDetailPage';
import APISettingBody from '@/features/Setting/APIModal/APISettingBody';
import AppearanceSettingBody from '@/features/Setting/Appearance/AppearanceSettingBody';
import ExportHistorySettingBody from '@/features/Setting/ExportHistory/ExportHistoryBody';
import FilterItemsAnalysisBody from '@/features/Setting/FilterItems/FilterItemsAnalysisBody';
import FilterItemsImportingBody from '@/features/Setting/FilterItems/FilterItemsImportingBody';
import GeneralSettingBody from '@/features/Setting/General/GeneralSettingBody';
import IntegrationPlatformTab from '@/features/Setting/Integrations/IntegrationPlatformTab';
import { IntegrationScrapingTab } from '@/features/Setting/Integrations/IntegrationScrapingTab';
import IntegrationSettingLayout from '@/features/Setting/Integrations/IntegrationSettingLayout';
import { LabsSettingBody } from '@/features/Setting/Labs/LabsSettingBody';
import MemberSettingBody from '@/features/Setting/Members/MembersSettingBody';
import MyAccountSettingBody from '@/features/Setting/MyAccount/MyAccountSettingBody';
import SearchSettingBody from '@/features/Setting/Search/SearchSettingBody';
import SlackChatBotConnection from '@/features/Setting/SlackChatBotConnection/SlackChatBotConnection';
import TagSettingBody from '@/features/Setting/Tags/TagsSettingBody';
import Topic2Detail from '@/features/Taxonomy/components/Topic2Detail/Topic2Detail';
import Topic2DetailLayout from '@/features/Taxonomy/components/Topic2Detail/Topic2DetailLayout';
import TaxonomyListPage from '@/features/Taxonomy/TaxonomyListPage';
import SettingLayout from '@/layouts/SettingLayout';
import SuspenseLayout from '@/layouts/SuspenseLayout';

const settingRoutes = (
  <Route path="settings" element={<SettingLayout />}>
    <Route element={<SuspenseLayout />}>
      <Route index element={<Navigate to="my-account" replace />} />
      <Route path="my-account" element={<MyAccountSettingBody />} />
      <Route path="filter-visibility" element={<FilterVisibilityPage />} />
      <Route path="api" element={<APISettingBody />} />
      <Route path="appearance" element={<AppearanceSettingBody />} />
      <Route path="general" element={<GeneralSettingBody />} />
      <Route path="integration" element={<IntegrationSettingLayout />}>
        <Route index element={<Navigate to="platform" replace />} />
        <Route path="platform" element={<IntegrationPlatformTab />} />
        <Route path="scraping" element={<IntegrationScrapingTab />} />
      </Route>
      <Route
        path="integration/scraping/:jobId"
        element={<ScrapingDetailPage />}
      />
      <Route path="members" element={<MemberSettingBody />} />
      <Route path="search" element={<SearchSettingBody />} />
      <Route path="taxonomy">
        <Route index element={<TaxonomyListPage />} />
        <Route path=":taxonomy_alias">
          <Route element={<Topic2DetailLayout />}>
            <Route path="feedback" element={<Topic2Detail />} />
            <Route path="topic/:topic_alias" element={<Topic2Detail />} />
          </Route>
        </Route>
      </Route>
      <Route path="tags" element={<TagSettingBody />} />
      <Route path="charts" element={<ChartListPage />} />
      <Route path="exclusion-analysis" element={<FilterItemsAnalysisBody />} />
      <Route
        path="exclusion-importing"
        element={<FilterItemsImportingBody />}
      />
      <Route path="export-history" element={<ExportHistorySettingBody />} />
      <Route path="slack-chatbot" element={<SlackChatBotConnection />} />
      <Route path="labs" element={<LabsSettingBody />} />
      <Route path="product-info" element={<ProductManagerPage />} />
    </Route>
  </Route>
);

export default settingRoutes;
